import React from "react";
import ReactECharts from "echarts-for-react";

const AnalysisChart = ({ faultData }) => {
  const result = faultData || {};

  const redStop = result.red_stop_data?.[0]?.vehicleid_red_stop?.value || 0;
  const amberWarning =
    result.amber_warning_data?.[0]?.vehicleid_amber_warning?.value || 0;
  const malfunction =
    result.malfunction_data?.[0]?.vehicleid_malfunction?.value || 0;
  const protect = result.protect_lamp_data?.[0]?.vehicleid_protect?.value || 0;

  const options = {
    title: {
      text: "Lamp Count",
      left: "center",
      top: "46%",
      textStyle: {
        fontSize: 15,
        color: "#000",
      },
    },
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "horizontal",
      bottom: 10,
      data: ["Red Stop", "Amber Warning", "Malfunction Indicator", "Protector"],
    },
    color: ["#ea3232", "#ffa300", "#eac100", "#b8ea00"],
    series: [
      {
        name: "Fault Codes",
        type: "pie",
        radius: ["45%", "70%"],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 3,
          borderColor: "#fff",
          borderWidth: 2,
        },
        label: {
          show: true,
          position: "inside",
          formatter: "{d}%",
          color: "#ffffff",
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: true,
          length: 15,
          length2: 10,
        },
        data: [
          { value: redStop, name: "Red Stop" },
          { value: amberWarning, name: "Amber Warning" },
          { value: malfunction, name: "Malfunction Indicator" },
          { value: protect, name: "Protector" },
        ],
      },
    ],
  };

  return (
    <div className="bg-white border border-gray-300 rounded-md overflow-hidden w-96 md:w-1/2">
      <h2 className="w-full text-md bg-[#056DB3] text-white  rounded-t-md p-1 pl-2 font-semibold mb-2">
        Fault Code Analysis
      </h2>
      <div style={{ paddingBottom: "40px" }}>
        <ReactECharts option={options} style={{ height: "380px" }} />
      </div>
    </div>
  );
};

export default AnalysisChart;
